import { useNavigateWithSearch } from "hooks/useNavigateWithSearch";
import AccordionTemplate from "components/accordions/accordion-template/AccordionTemplate";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";
import { useContactInformation } from "../../../hooks/useContactInformation";
import { ROUTES, CARD_FRAGMENTS } from "routes/constants";

const StatementOfHealthAccordion = () => {
    const navigate = useNavigateWithSearch();
    const { contactData } = useContactInformation();

    const statementOfHealthData = contactData?.statementOfHealth;

    const handleEdit = () => {
        pushGTMEvent(GA_EVENT_CONFIGS.REVIEW_EDIT_HEALTH);
        navigate(`${ROUTES.APPLICATION.CONTACT}${CARD_FRAGMENTS.STATEMENT_OF_HEALTH}`);
    };

    return (
        <AccordionTemplate
            title="Statement Of Health"
            accordionName="your-review-information"
            onEdit={handleEdit}
            dataTestId="statement-of-health-accordion"
        >
            <div className="flex gap-32 mb-4">
                <div>
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Height</p>
                        <p className="text-base-content text-sm font-medium">
                            {statementOfHealthData?.heightFeet} ft {statementOfHealthData?.heightInches} in
                        </p>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col gap-1">
                        <p className="text-base-content text-sm font-semibold">Weight</p>
                        <p className="text-base-content text-sm font-medium">{statementOfHealthData?.weight} lbs</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-1 mb-4">
                <p className="text-base-content text-sm font-semibold">
                    In the last 12 months, have you used nicotine in any form?
                </p>
                <p className="text-base-content text-sm font-bold">{statementOfHealthData?.hasUsedNicotine ? "Yes" : "No"}</p>
            </div>
            <div className="flex flex-col gap-1 mb-4">
                <p className="text-base-content text-sm font-semibold">
                    In the past three years, have you received any treatment for OR been diagnosed by a doctor as having heart
                    trouble, cancer, stroke, lung disease, liver disease, kidney disease, AIDS, lupus, ALS, schizophrenia or
                    dementia?
                </p>
                <p className="text-base-content text-sm font-bold">
                    {statementOfHealthData?.hasMedicalConditions ? "Yes" : "No"}
                </p>
            </div>
            <div className="flex flex-col gap-1 mb-4">
                <p className="text-base-content text-sm font-semibold">
                    In the past 12 months, have you had diagnostic testing performed or recommended by a doctor for an
                    undiagnosed condition?
                </p>
                <p className="text-base-content text-sm font-bold">
                    {statementOfHealthData?.hasDiagnosticTesting ? "Yes" : "No"}
                </p>
            </div>
        </AccordionTemplate>
    );
};

export default StatementOfHealthAccordion;
